import DOMPurify from 'dompurify';
import { domPurifyConfig } from 'shared/helpers/HTMLSanitizer';

DOMPurify.addHook(
  'afterSanitizeAttributes',
  domPurifyConfig.hooks.afterSanitizeAttributes
);

function applyToShadow(shadow, binding) {
  const value = binding.value;
  if (typeof value === 'string') {
    shadow.innerHTML = DOMPurify.sanitize(value || '');
  } else {
    const sanitizedHtml = DOMPurify.sanitize(value.html || '');
    shadow.innerHTML = `<style>${value.styles || ''}</style>${sanitizedHtml}`;
  }
}

export default {
  inserted(el, binding) {
    const shadow = el.shadowRoot || el.attachShadow({ mode: 'open' });
    applyToShadow(shadow, binding);
  },
  update(el, binding) {
    if (el.shadowRoot && binding.value !== binding.oldValue) {
      applyToShadow(el.shadowRoot, binding);
    }
  },
};
